// DO NOT EDIT !!!!
// this file is automatically generated by git-version.js script
export const version_info = {hostVersion: 'release/1.7', version: 'fa31e0e57933e220aae5f3f0e0d6ac2ef707e7f7', date: '4/28/2026 12:46:30 PM', buildDate: '4/28/2026 12:47:35 PM'};
